import { isNewPlant, formatDate } from "../lib/theme";

export function NewMark({ plant, className = "h-3.5 w-3.5", testid }) {
  if (!isNewPlant(plant)) return null;
  const label = `New · added ${formatDate(plant.created_at)}`;
  return (
    <span title={label} aria-label={label} role="img" data-testid={testid} className="inline-flex shrink-0">
      <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden>
        <path d="M10 2.5c.5 4.6 2.4 6.5 7 7-4.6.5-6.5 2.4-7 7-.5-4.6-2.4-6.5-7-7 4.6-.5 6.5-2.4 7-7z" fill="#F5B301" />
        <path d="M18.5 13.5c.3 2.4 1.1 3.2 3.5 3.5-2.4.3-3.2 1.1-3.5 3.5-.3-2.4-1.1-3.2-3.5-3.5 2.4-.3 3.2-1.1 3.5-3.5z" fill="#FFCC33" />
      </svg>
    </span>
  );
}

export default NewMark;
